import { Div, state } from '@codesuma/baseline'
import style from './index.module.css'

// The one thing the app cannot put right on the user's behalf: storage that
// will not take what they saved.
//
// It is raised for both shapes of that — see services/storage. A session that
// could not open the database is showing an older copy and cannot store new
// work in the usual place; a session whose write failed has something it is
// still holding. Either way the honest thing is to say the app is not keeping
// up, rather than let a saved item quietly not be there tomorrow.
//
// Dismissable, and it comes back if storage fails again afterwards. It says
// nothing about which item, because the store is the thing at fault and naming
// one row would suggest the rest are safe.

const TEXT = 'ذخیره‌سازی روی این دستگاه درست کار نمی‌کند.'
    + ' ممکن است چیزی که می‌بینید تازه نباشد و تغییرهای شما نگه داشته نشوند.'

export const StorageNotice = () => {
    const base = Div()
    base.addClass(style.base)
    base.el.hidden = true

    const text = Div(TEXT)
    text.addClass(style.text)

    const dismiss = Div('باشه')
    dismiss.addClass(style.dismiss)
    dismiss.el.setAttribute('role', 'button')
    dismiss.el.setAttribute('tabindex', '0')
    dismiss.el.setAttribute('data-ripple', '')
    dismiss.el.addEventListener('click', () => { base.el.hidden = true })

    base.append(text, dismiss)

    // Watched by value rather than raised once: storage can fail long after
    // boot, and it can come right again on the next save.
    state.on('storage-degraded', (on: boolean) => { base.el.hidden = !on })
    if (state.get('storage-degraded')) base.el.hidden = false

    return base
}
